import { Button, Image, makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles({
  base: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    gap: tokens.spacingHorizontalS,
    margin: tokens.spacingHorizontalL,
    justifyContent: 'center',
    alignItems: 'center',
  }
})

export const AppFeaturesEmpty: React.FC<{
  onClick: () => void;
  buttonText: string;
}> = ({ onClick, buttonText }) => {
  const intl = useIntl();
  const classes = useStyles();
  return (
    <div className={classes.base}>
      <Image
        src="/images/svg/app-features-empty.svg"
        alt={intl.formatMessage({ defaultMessage: 'Empty state icon', description: 'Icon for empty state' })}
        width={200} height={200}
      />
      <Button onClick={onClick} appearance="primary">
        {buttonText}
      </Button>
    </div>
  )
}